// Vue
import { createApp } from 'vue'
import App from '@/App.vue'
import router from './router';
import { IonicVue } from '@ionic/vue';

// Ionic
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

// Google Maps
import { Loader } from 'google-maps';

// 設定ファイル読み込み
import * as Conf from './conf';

// メモった！、キニッタ！共通
import * as GVar from '@/components/00/Var00';  // 共通変数
import * as Tools from '@/components/00/Tools'; // 共通ツール
import * as GFunc from '@/components/00/Common00';  // 共通メソッド

// メモった！、キニッタ！共通css
import '@/assets/00/css/common.css'; 

// キニッタ！専用
import * as LFunc from '@/components/05/Common05002'; // キニッタ！専用メソッド

// キニッタ！専用css
import '@/assets/05/css/help.css'; 
import '@/assets/05/css/p05002.css';

// QRコード用
import VueQrcode from '@chenfengyuan/vue-qrcode';

// FloatingVue(tooltip用)
import FloatingVue from "floating-vue";
import 'floating-vue/dist/style.css'

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(FloatingVue)
  ;

// QRコード用準備
app.component(VueQrcode.name!, VueQrcode);
  
router.isReady().then(() => {
  app.mount('#app');
});


// 初期処理呼び出し
init();

/**
 * 初期定理
 */
async function  init()
{
  if ( GFunc.isDebugEnabled() ) {console.log("main init()");}

    //
    // 共通環境設定
    //

    // 実行環境設定
    GVar.setEnv(Conf.env);
    // デバッグフラグ設定 true/false
    GVar.setDebugEnabled(Conf.debugFlag[Conf.env]);
      if ( GFunc.isDebugEnabled() ) {console.log("App onMounted()");}    
    // サーブレットURLをセット
    GVar.setServerUrl(Conf.serverUrl[GVar.env]);
    GVar.setServerUrl2(Conf.serverUrl2[GVar.env]);
  
    //
    // キニッタ！専用s
    //

    // システムコード設定
    GVar.setSysCd("05");
    // テンプレートコード設定
    GVar.setTmpltCd("002");
    // プロダクト名設定
    GVar.setProductName(LFunc.getProperty("product.name.05.002")!);
    // ログインページ
    GVar.setLoginPage("S05002000");
    // トップページ設定
    GVar.setTopPage("S05002000");

    // 共通画面ラベルの設定
    GVar.setLblTitle(GFunc.getProperty('sproduct.name.05.002')!);
    GVar.setLblFooter(GFunc.getProperty('product.name.05.002')!);
    GVar.setLblLogout(GFunc.getProperty('screen.common.label.logout')!);
    GVar.setLblNm(GFunc.getProperty('screen.P109009.label.name')+":");
    // 日付設定
    GVar.setToday(new Date());

    // デバイスID取得は同期が必要
    const did = await Device.getId();
    GVar.setDeviceId(did.uuid);

    // Google Mapロード
    GVar.setMapLoader(new Loader(GVar.apiKeys[Capacitor.getPlatform()]));
    
    // 端末タイプ設定
    GVar.setTtype(GFunc.getProperty("TERMINAL.OS.NAME.OTHERS")!);

     // ログインページに遷移する
    // router.push({name: GVar.topPage});

}